<template>
    <div id="story-card">
        <div class="row align-end">
            <div class="col-2">
                <input-text v-model="search" :placeholder="$t('Search')" ref="input-search"/>
            </div>
            <div class="col-2">
                <input-select :items="[{text:$t('Alphabetical'), value:'abc'},{text:$t('Last edit'), value:'date'}]" v-model="order" :placeholder="$t('Order')" />
            </div>
            <div class="col" v-if="search !== ''">
                <btn square @click="search = ''">
                    <i class="fal fa-times"></i>
                </btn>
            </div>
        </div>
        <div class="row wrap" v-if="type !== 'annotation'">
            <div class="card" @click="$emit('add')" v-if="type !== 'all' && type !== 'annotation'">
                <div class="image">
                    <i class="fa fa-plus"></i>
                </div>
                <div class="text">
                    {{$t('New ')}} {{$store.getters.labelByType(type)}}
                </div>
            </div>
            <card v-for="item in filterItems"
                  :key="item.getId()"
                  :item="item"
                  :active="isSelected(item)"
                  :canDelete="canDelete"
                  :showType="true"
                  @select="$emit('select',item)"
                  @remove="$emit('remove',item)"
            />
        </div>
        <div class="row wrap" v-else>
            <annotation-edit
                v-for="item in filterItems"
                :key="item.getId()"
                :annotation="item"
                :active="isSelected(item)"
                @select="(annotation) => $emit('select',annotation)"
                @refresh="refreshAnnotation"
            />
        </div>
    </div>
</template>

<script>
import InputSelect from '@/modules/input/input-select'
import InputText from '@/modules/input/input-text'
import {story} from '@/class/story'
import Btn from '@/modules/buttons/btn'
import Tooltip from '@/modules/tooltip'
import tools from '@/class/tools'
import Card from '@/modules/items/card'
import AnnotationEdit from '@/modules/annotation/annotation-edit'
import {annotation} from '@/class/annotation/annotation'
import events from '@/events/events'

export default {
  name: 'Story_Cards',
  components: {AnnotationEdit, Card, Tooltip, Btn, InputText, InputSelect},
  props:{
    story:{type:Object, default:() => new story()},
    type:{type:String},
    selected:{type:Object},
    canDelete:{type:Boolean, default:false}
  },
  data () {
    return {
      search:'',
      order:'abc',

      newAnnotation: null
    }
  },
  methods:{
    isSelected (item) {
      if (!this.selected) return false
      return item.getId() === this.selected.id && this.type === this.selected.type
    },
    refreshAnnotation () {
      this.story.load()
    },
    uneditAnnotation () {
      if (this.type === 'annotation') {
        this.filterItems.map(annotation => annotation.unEdit())
      }
    }
  },
  computed:{
    filterItems () {

      const search = tools.removeAccents(this.search)
      const items = this.story.getItems(this.type).filter(i => tools.removeAccents(i.getName()).match(search))

      items.sort((item1, item2) => {
        if (this.order === 'abc') {

        } else if (this.order === 'date') {

        }
      })

      return items
    }
  },
  watch:{
    type () {
      this.$refs['input-search'].$refs['input'].focus()
    }
  },
  mounted () {
    this.$refs['input-search'].$refs['input'].focus()
    events.$on('body:click:dblclick', this.uneditAnnotation)
  },
  destroyed () {

    events.$off('body:click:dblclick', this.uneditAnnotation)
  }
}
</script>
